import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgDrag = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.85714 19.1429V22H2V19.1429H4.85714ZM10.5714 19.1429V22H7.71429V19.1429H10.5714ZM16.2857 19.1429V22H13.4286V19.1429H16.2857ZM22 19.1429V22H19.1429V19.1429H22ZM4.85714 13.4286V16.2857H2V13.4286H4.85714ZM10.5714 13.4286V16.2857H7.71429V13.4286H10.5714ZM16.2857 13.4286V16.2857H13.4286V13.4286H16.2857ZM22 13.4286V16.2857H19.1429V13.4286H22ZM4.85714 7.71429V10.5714H2V7.71429H4.85714ZM10.5714 7.71429V10.5714H7.71429V7.71429H10.5714ZM16.2857 7.71429V10.5714H13.4286V7.71429H16.2857ZM22 7.71429V10.5714H19.1429V7.71429H22ZM4.85714 2V4.85714H2V2H4.85714ZM10.5714 2V4.85714H7.71429V2H10.5714ZM16.2857 2V4.85714H13.4286V2H16.2857ZM22 2V4.85714H19.1429V2H22Z", fill: props.fill }));
});
export default SvgDrag;
